import { render, staticRenderFns } from "./instructionFolderAction.vue?vue&type=template&id=2be8da2a"
import script from "./instructionFolderAction.vue?vue&type=script&lang=js"
export * from "./instructionFolderAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports